import {
    formatAttachmentSize,
    type UploadedEmailAttachment,
} from "../lib/email-attachments";

interface EmailAttachmentListProps {
    attachments: UploadedEmailAttachment[];
    onRemove: (attachment: UploadedEmailAttachment) => void;
}

export default function EmailAttachmentList({
    attachments,
    onRemove,
}: EmailAttachmentListProps) {
    if (attachments.length === 0) return null;

    return (
        <div className="email-attachment-list" aria-label="Email attachments">
            {attachments.map(attachment => (
                <span className="email-attachment-chip" key={attachment.key}>
                    <span>
                        {attachment.filename}
                        <small>
                            {attachment.disposition === "inline" ? "inline image" : "attachment"}
                            {" | "}
                            {formatAttachmentSize(attachment.size)}
                        </small>
                    </span>
                    <button
                        type="button"
                        onClick={() => onRemove(attachment)}
                        aria-label={`Remove ${attachment.filename}`}
                        title={`Remove ${attachment.filename}`}
                    >
                        x
                    </button>
                </span>
            ))}
        </div>
    );
}
